import { Route, Routes } from "react-router-dom";
import { StyleGuideHome } from "./StyleGuideHome.tsx";
import { TypographyGuide } from "./typography/TypographyGuide.tsx";
import { ButtonGuide } from "./buttons/ButtonGuide.tsx";
import { ColorPaletteGuide } from "./color-palette/ColorPaletteGuide.tsx";
import { SpacingLayoutGuide } from "./spacing/SpacingGuide.tsx";
import { ComponentsGuide } from "./components/ComponentGuide.tsx";

export const StyleGuideRoutes = () => {
  return (
    <Routes>
      <Route index element={<StyleGuideHome />} />
      <Route path="typography" element={<TypographyGuide />} />
      <Route path="buttons" element={<ButtonGuide />} />
      <Route path="colors" element={<ColorPaletteGuide />} />
      <Route path="spacing" element={<SpacingLayoutGuide />} />
      <Route path="components" element={<ComponentsGuide />} />
    </Routes>
  );
};
